module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/common/promoter-selection-box/promoter-selection-box.component.scss
// module id = ./src/app/modules/boxoffice-module/common/promoter-selection-box/promoter-selection-box.component.scss
// module chunks = 9